import { render } from "./PrivacyContent.vue?vue&type=template&id=5edaf136&scoped=true"
import script from "./PrivacyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyContent.vue?vue&type=script&lang=js"

import "./PrivacyContent.vue?vue&type=style&index=0&id=5edaf136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edaf136"]])

export default __exports__